export default "/institutions/itau-personnalite.svg";